

import reducer from './reducer';
import {createStore } from 'redux';


// ==============================|| REDUX - MAIN STORE ||============================== //

const store = createStore(reducer);
const persister = 'Free';

export { store, persister };
